module.exports = __webpack_public_path__ + "assets/340972382c56caf8f4ac9df75416fb72.png";